<template>
	<div>
		<page-header>
			<template #title>
				<router-link :to="{ name: 'facilities' }" v-text="`Facilities /`" />
				<span>{{ entity.display_name }}</span>
			</template>
			<template #buttons>
				<b-button
					variant="light"
					:to="{ name: 'facilities.edit', params: { id: $route.params.id } }"
					title="Edit"
					class="btn btn-outline-primary"
				>
					<font-awesome-icon icon="edit" fixed-width />
					<span>Edit</span>
				</b-button>

				<b-dropdown variant="secondary" right title="More Options">
					<template #button-content>
						<font-awesome-icon icon="cog" fixed-width />
					</template>

					<b-dropdown-item :to="{ name: 'cases.add', query: { facility_id: $route.params.id } }">
						<font-awesome-icon icon="plus" fixed-width />
						<span>New Case</span>
					</b-dropdown-item>

					<b-dropdown-divider />

					<b-dropdown-item @click="destroy" :disabled="loading" variant="danger" disabled>
						<font-awesome-icon icon="trash" fixed-width />
						<span>Delete</span>
					</b-dropdown-item>
				</b-dropdown>
			</template>
		</page-header>

		<loading-indicator v-if="showLoading" class="my-5" />
		<div v-else class="my-4">
			<b-row>
				<b-col v-if="entity.full_address" cols="12" class="mb-2">
					<p class="text-muted mb-0" title="Address">
						<font-awesome-icon icon="location-dot" fixed-width />
						{{ entity.full_address }}
					</p>
				</b-col>
				<b-col cols="12" sm="6" lg="6" class="mb-2">
					<!-- <b-badge pill variant="primary" v-if="entity.facility_status">Active</b-badge>
					<b-badge pill variant="secondary" v-else>Inactive</b-badge> -->
					<!-- <b-badge pill 
						v-if="entity.is_encore === 1"
						variant="success" 
					>
						
						Encore
                	</b-badge> -->
					
					<b-badge pill 
						v-if="entity.facility_status === 'Pending'"
						:style="{ backgroundColor: '#6c757d', color: '#ffffff' }"
					>
						Pending Term
					</b-badge>
					<b-badge pill 
						v-if="entity.facility_status === 'Active'"
						:style="{ backgroundColor: '#97ECF1', color: '#000000' }"
					>
						Active 
					</b-badge>
					<b-badge pill 
						v-if="entity.facility_status === 'Inactive'"
						:style="{ backgroundColor: '#FFADAD', color: '#000000' }"
					>
						Inactive 
					</b-badge>
					<!-- <b-badge :pill="true" :variant="badgeVariant">{{ badgeText }}</b-badge> -->
					<b-badge pill v-if="entity.client_owned" :style="{ backgroundColor: '#DFFDFF', color: '#000' }"> Owned </b-badge>
					<b-badge pill 
						v-if="entity.is_encore === 1"
						variant="succes"
						style="background-color: #e49643; color: white;" 
					>
						Encore
					</b-badge>
					<b-badge pill v-if="entity.has_contract" variant="info"> Contract </b-badge>
					<b-badge pill 
						v-if="entity.is_duplicate"
						variant="warning" 
					>
						Do Not Use 
					</b-badge>
				</b-col>
				<b-col cols="12" sm="6" lg="6" class="mb-2 text-sm-right">
					<p class="small text-muted">
						<span> Last updated {{ $filters.fromNow(entity.modified) }} </span>
						<span v-if="entity.modified_by_user?.full_name">
							by {{ entity.modified_by_user.full_name }}
						</span>
					</p>
				</b-col>
			</b-row>

			<b-card no-body class="shadow-sm">
				<b-tabs card active-nav-item-class="font-weight-bold">
					<b-tab no-body active lazy>
						<template #title>Details</template>
						<b-row>
							<b-col cols="10" sm="5" lg="5" class="mb-4 ml-4 mt-2">
								<h6 class="h6 text-uppercase font-weight-bold text-muted">Details</h6>
								<div class="table-responsive">
									<table class="table table-sm table-headers-muted table-data-right mb-0">
										<tr>
											<th>Main Type</th>
											<td>
												<span v-if="entity.facility_type && entity.facility_type.name">
													{{ entity.facility_type.name }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>Chain</th>
											<td>
												<span v-if="entity.chain_name">
													{{ entity.chain_name }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>Area</th>
											<td>
												<span v-if="entity.area_name">
													{{ entity.area_name }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>OU Number</th>
											<td>
												<span v-if="entity.ou_number">
													{{ entity.ou_number }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>Territory</th>
											<td>
												<span v-if="entity.territory">
													{{ entity.territory }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>Division</th>
											<td>
												<span v-if="entity.division">
													{{ entity.division }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>Region</th>
											<td>
												<span v-if="entity.region">
													{{ entity.region }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
										<tr>
											<th>Facility Name</th>
											<td>
												<span v-if="entity.display_name">
													{{ entity.display_name }}
												</span>
												<span v-else class="text-muted">&mdash;</span>
											</td>
										</tr>
									</table>
								</div>
							</b-col>
							<!-- <b-col cols="12" sm="6" lg="6" class="mb-4"> -->
								<b-col cols="5" sm="5" lg="5" class="mb-4 ml-4 mt-2">
								<h6 class="h6 text-uppercase font-weight-bold text-muted">Contact</h6>
								<div class="table-responsive">
									<table class="table table-sm table-headers-muted table-data-right mb-0">
										<tr>
											<th>Phone</th>
											<td>
												<span v-if="entity.phone">
													<a
														:href="$filters.linkTel(entity.phone)"
														class="font-weight-bold text-decoration-none"
														>{{ $filters.formatPhone(entity.phone) }}</a
													>
												</span>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
										<tr>
											<th>Fax</th>
											<td>
												<span v-if="entity.fax">
													<a
														:href="$filters.linkTel(entity.fax)"
														class="font-weight-bold text-decoration-none"
														>{{ $filters.formatPhone(entity.fax) }}</a
													>
												</span>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
										<th>Email</th>
										<td>
											<span v-if="entity.email">
												<a
													:href="'mailto:' + entity.email"
													class="font-weight-bold text-decoration-none"
													>{{ entity.email }}</a
												>
											</span>
											<span v-else class="text-muted"> &mdash; </span>
										</td>
									</table>
								</div>
								
								<h6 class="h6 text-uppercase font-weight-bold text-muted mt-5">Outgoing Methods</h6>
								<div class="table-responsive">
									<table class="table table-sm table-headers-muted table-data-right mb-0">

										<tr>
											<th>Emails</th>
											<td>
												<!-- <span v-if="entity.receiving_emails && Array.isArray(entity.receiving_emails) && entity.receiving_emails.length > 0">
													{{ entity.receiving_emails.map(emailObj => `${emailObj.email}(${emailObj.description})`).join(', ') }}
												</span> -->
												<span v-if="receivingEmails && Array.isArray(receivingEmails) && receivingEmails.length > 0">
													{{ receivingEmails.map(emailObj => `${emailObj.email}(${emailObj.description})`).join(', ') }}
												</span>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
									<!-- <tr><th>Emails</th></tr> -->
									<!-- <tr v-if="entity.receiving_emails && entity.receiving_emails.length > 0" v-for="email in entity.receiving_emails" :key="email.index"> -->
																			<!-- <td class="text-center"> -->
																				<!-- <b-link :to="{ name: 'services.view', params: { id: service.id } }" class="font-weight-bold text-decoration-none"> -->
																					<!-- {{ receiving_emails.email }} -->
																				<!-- </b-link> -->
																			<!-- </td> -->
																		<!-- </tr>
																		<tr v-else>
																			<td class="text-muted">No emails</td>
																		</tr> -->

									<tr>
            <th>Faxes</th>
            <td>
                <span v-if="receiving_faxes && receiving_faxes.length > 0">
                    {{ receiving_faxes.map(faxObj => `${faxObj.fax} (${faxObj.description})`).join(', ') }}
                </span>
                <span v-else class="text-muted"> &mdash; </span>
            </td>
        </tr>

    </table>
</div>

							</b-col>
							<!-- <b-col cols="12" sm="6" lg="6" class="mb-4"> -->
								<b-col cols="10" sm="5" lg="5" class="mb-4 ml-4 mt-2">
								<h6 class="h6 text-uppercase font-weight-bold text-muted">Contract</h6>
								<div class="table-responsive">
									<table class="table table-sm table-headers-muted table-data-right mb-0">
										<tr>
											<th>Has Contract</th>
											<td>
												<div v-if="entity.has_contract">Yes</div>
												<div v-else>No</div>
											</td>
										</tr>
										<tr v-for="(facility, index) in contractFacility" :key="index.facility_id">
											<th>Start Date</th>
											<td>
												<div v-if="facility.contract_effective_date">
													<p class="mb-0">
														{{ $filters.formatDate(facility.contract_effective_date) }}
													</p>
													<!-- <p class="small text-muted mb-0">
														{{ $filters.fromNow(entity.contract_start_date) }}
													</p> -->
												</div>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
										<tr v-for="(facility, item) in contractFacility" :key="item.facility_id">
											<th>End Date</th>
											<td>
												<div v-if="facility.expiration_date">
													<p class="mb-0">
														{{ $filters.formatDate(facility.expiration_date) }}
													</p>
													<!-- <p class="small text-muted mb-0">
														{{ $filters.fromNow(entity.contract_end_date) }}
													</p> -->
												</div>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
										<tr v-for="(facility, i) in contractFacility" :key="i.facility_id">
											<th>Indemnification Days</th>
											<td>
												<span v-if="facility.indemnification_days">
													{{ facility.indemnification_days }}
												</span>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
										<tr v-for="(facility, j) in contractFacility" :key="j.facility_id">
											<th>Max Return Work Days</th>
											<td>
												<span v-if="facility.max_return_days">
													{{ facility.max_return_days }}
												</span>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
									</table>
								</div>
							</b-col>
							<!-- <b-col cols="10" sm="5" lg="5" class="mb-4 ml-4 mt-2 text-center">
    <h6 class="h6 text-uppercase font-weight-bold text-muted">Receiving Information</h6>

    <div class="table-responsive">
        <table class="table table-sm table-headers-muted table-data-right mb-0 mx-auto">
            <tbody>
                <tr v-if="entity.receivingInfo && entity.receivingInfo.email">
                    <th>Email</th>
                    <td class="align-middle">
                        <span v-if="entity.receivingInfo.email">
                            <a
                                :href="'mailto:' + entity.receivingInfo.email"
                                class="font-weight-bold text-decoration-none"
                            >{{ entity.receivingInfo.email }}</a>
                        </span>
                        <span v-else class="text-muted"> &mdash; </span>
                    </td>
                </tr>
                <tr v-if="entity.receivingInfo && entity.receivingInfo.fax">
                    <th>Fax</th>
                    <td class="align-middle">
                        <span v-if="entity.receivingInfo.fax">
                            <a
                                :href="$filters.linkTel(entity.receivingInfo.fax)"
                                class="font-weight-bold text-decoration-none"
                            >{{ $filters.formatPhone(entity.receivingInfo.fax) }}</a>
                        </span>
                        <span v-else class="text-muted"> &mdash; </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
	</b-col> -->
							<!-- <b-col cols="10" sm="5" lg="5" class="mb-4 ml-4 mt-2">
								<h6 class="h6 text-uppercase font-weight-bold text-muted">Receiving Information</h6>
								<div class="table-responsive">
									<table class="table table-sm table-headers-muted table-data-right mb-0">

										<tr>
											<th>Fax</th>
											<td>
												<span v-if="entity.fax">
													<a
														:href="$filters.linkTel(entity.fax)"
														class="font-weight-bold text-decoration-none"
														>{{ $filters.formatPhone(entity.fax) }}</a
													>
												</span>
												<span v-else class="text-muted"> &mdash; </span>
											</td>
										</tr>
										<th>Email</th>
										<td>
											<span v-if="entity.email">
												<a
													:href="'mailto:' + entity.email"
													class="font-weight-bold text-decoration-none"
													>{{ entity.email }}</a
												>
											</span>
											<span v-else class="text-muted"> &mdash; </span>
										</td>
									</table>
								</div>
							</b-col> -->

							<!-- <b-col cols="10" sm="6" lg="6" class="mb-4"> -->
								<!-- <b-col cols="10" sm="5" lg="5" class="mb-0 ml-4 mt-2">
								<h6 class="h6 text-uppercase font-weight-bold text-muted">Services</h6>

								<b-list-group v-if="entity.services && entity.services.length > 0">
									<b-list-group-item
										v-for="service in entity.services"
										:key="service.index"
										:to="{ name: 'services.view', params: { id: service.id } }"
									>
										{{ service.name }}
									</b-list-group-item>
								</b-list-group>
								<empty-result v-else> No services assigned </empty-result>
							</b-col> -->
							<b-col cols="10" sm="5" lg="5" class="mb-4 ml-4 mt-2" :sm-offset="5" :lg-offset="5">
								<h6 class="h6 text-uppercase font-weight-bold text-muted">Services</h6>

								<div class="table-responsive">
									<table class="table table-sm table-headers-muted table-data-right mb-0 mx-auto">
										<tbody>
											<tr v-if="entity.services && entity.services.length > 0" v-for="service in entity.services" :key="service.index">
												<td class="text-center">
													<b-link :to="{ name: 'services.view', params: { id: service.id } }" class="font-weight-bold text-decoration-none">
														{{ service.name }}
													</b-link>
												</td>
											</tr>
											<tr v-else>
												<td class="text-muted">No services assigned</td>
											</tr>
										</tbody>
									</table>
								</div>
							</b-col>





						</b-row>
					</b-tab>
					<b-tab no-body  lazy>
						<template #title>Cases</template>
						<case-index
							ref="caseList"
							hide-facility
							:filters="caseFilters"
							@clicked="viewCase"
							empty-description="No cases have been created for this facility."
						/>
					</b-tab>
					<b-tab no-body lazy>
						<template #title>Add Case</template>
						<case-form flush :facility-id="$route.params.id" :facility-data="entity" @viewCase="viewCase"/>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>

<script type="text/javascript">
import { get as GetFacility, destroy as DeleteFacility } from "@/clients/services/facilities";

import CaseForm from "@/clients/components/Cases/Form.vue";
import CaseIndex from "@/clients/components/Cases/Index.vue";
import axios from "axios";

export default {
	name: "FacilityView",
	components: {
		CaseForm,
		CaseIndex,
	},
	data() {
		return {
			loading: true,
			entity: {
				id: null,
				name: null,
				active: null,
				full_address: null,
				display_name:null,
				is_encore:null,
				// receiving_faxes: [], // For storing multiple faxes
            	// receiving_emails: [], // For storing multiple emails

			},
			similar: [],
			receivingEmails: [],
			receiving_faxes:[],
			contractFacility:[],
			facilityId:null,
			// entity: {
			// 	id: this.id,
			// 	name: "",
			// 	display_name:null,
			// 	facility_type_id: null,
			// 	active: true,
			// 	phone: null,
			// 	fax: null,
			// 	email: null,
			// 	// street_address_1: null,
			// 	// street_address_2: null,
			// 	city: null,
			// 	state: null,
			// 	zip: null,
			// 	npi_number: null,
			// 	npi_manual: null,
			// 	primary_taxonomy: null,
			// 	location_phone: null,
			// 	mailing_phone: null,
			// 	additional_taxonomies: null,
			// 	client_owned: true,
			// 	chain_name: '',
			// 	area_name: null,
			// 	ou_number: null,
			// 	territory: null,
			// 	// rvp_name: null,
			// 	has_contract: false,
			// 	contract_start_date: null,
			// 	contract_end_date: null,
			// 	indemnification_days: null,
			// 	max_return_work_days: null,
			// 	address_1: null,
			// 	address_2: null,
			// 	// taxonomy_code: null,
			// 	// taxonomy_desc: null,
			// 	// taxonomy_group: null,
			// 	// taxonomy_license:  null,
			// 	// taxonomy_state: null,
			// 	othername: null,
			// 	enumeration_type: null,
			// 	organizational_subpart:null,
			// 	services: [],
			// 	chains:[],
			// 	receiving_email: '', // For input
            // 	receiving_emails: [], // For storing multiple emails
			// 	receiving_fax: '', // For input
            // 	receiving_faxes: [], // For storing multiple faxes
			// 	// outgoing_emails: [],
            // 	receiving_methods: [], 


			// },
		};
	},
	computed: {
		badgeVariant() {
			// Assuming "entity.facility_status" holds the facility status value
			switch (this.entity.facility_status) {
				case 'Active':
					return 'primary';
				case 'Pending Term':
					return 'secondary'; 
				case 'Inactive':
					return 'danger';
				default:
					return 'info'; // Adjust the default variant as needed
			}
		},
		badgeText() {
			// Assuming "entity.facility_status" holds the facility status value
			switch (this.entity.facility_status) {
				case 'Active':
					return 'Active';
				case 'Pending Term':
					return 'Pending';
				case 'Inactive':
					return 'Inactive';
				default:
					return ''; // Adjust the default text as needed
			}
		},
		caseFilters() {
			return {
				facility_id: this.$route.params.id,
			};
		},
		showLoading() {
			return this.loading && (!this.entity.id || this.entity.id == null);
		},
	},
	mounted() {
		this.refresh();
		this.fetchReceivingEmails();
		this.fetchContractFacility();
		if (!localStorage.getItem('refreshed')) {
			localStorage.setItem('refreshed', 'true');
		} else {
			localStorage.removeItem('refreshed');
		}


		// this.addEmail();
		// console.log('entity:', this.entity);
        // console.log('entity.receiving_emails:', this.entity.receiving_emails);
        // console.log('Array.isArray(entity.receiving_emails):', Array.isArray(this.entity.receiving_emails));
        // console.log('entity.receiving_emails.length:', this.entity.receiving_emails.length);
		// this.$emit('Receiving_emails', [{ email: 'test@example.com', description: 'test' }]);
	},
	created() {
		
		// Listen for the emitted event
		// this.$root.$on('Receiving_emails', this.updateReceivingEmails);
  	},
	methods: {
		async fetchReceivingEmails() {
			try {
				// const response = await axios.get('/client/fetchReceivingEmails');
				// this.receivingEmails = response.data.receivingEmails;
				// console.log("API",this.receivingEmails);
				const url = window.location.href; // Get the current URL
				 this.facilityId = url.match(/\/facilities\/(\d+)/)[1]; // Extract facility ID from the URL
			
				const responseOutgoingData = await axios.post('/client/receivingEmails', {id:this.facilityId , fetch:true , add:false , edit:false , delete:false});
			
				if (responseOutgoingData.data && Array.isArray(responseOutgoingData.data)) {
						responseOutgoingData.data.forEach((item) => {
						
							if (item.receiving_email_id !== null) {
								
								try{
								this.receivingEmails.push({
									id: item.id,
									email: item.receiving_email_id,
									description: item.email_desc
									
								});
							}
							catch(e){
								
							}
							}

							if (item.receiving_fax_id !== null) {
								
								try{
								this.receiving_faxes.push({
									id: item.id,
									fax: item.receiving_fax_id,
									description: item.fax_desc
									
								});
							} catch(e){
								
							}
							}

						}); 
					

					}
			} catch (error) {
				console.error('Error fetching receiving emails:', error);
			}
			},
			async refresh() {
				this.loading = true;
				try {
					this.entity = await GetFacility(this.$route.params.id);
				} catch (e) {
					this.$router.push({ name: "facilities" });
				} finally {
					this.loading = false;
					try {
						await this.fetchContractFacility();
					} catch (e) {
						console.error('Error fetching contract facility:', e);
					}
				}
			},
		async destroy() {
			if (!confirm("Are you sure you want to delete this facility?")) {
				return;
			}

			try {
				this.deleting = true;
				const response = await DeleteFacility(this.$route.params.id);
				this.$store.dispatch("facilities/getActive");
				this.$router.push({ name: "facilities" });

				this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "primary",
						title: "Facility Deleted",
						message: `Facility ${response.data.name} was deleted.`,
					});
				});
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					title: "Delete Failed",
					message: "Failed to delete facility",
				});
			} finally {
				this.deleting = false;
			}
		},
		viewCase(caseEntity) {
			this.$router.push({
				name: "cases.view",
				params: {
					id: caseEntity.id,
				},
			});
		},
		async fetchContractFacility() {
				try {
					const url = "/client/fetchcontractfacility";
					const response = await axios.get(url, {
						headers: {
							"Accept": "application/json",
						},
					});

					const facilityId = typeof this.facilityId === 'string' ? parseInt(this.facilityId) : this.facilityId;

					this.contractFacility = response.data.filter(item => item.facility_id === facilityId);
				
				} catch (error) {
					console.error("Error fetching contract facility data:", error.message);
				}
			},

	},
	watch: {
		"$route.params.id": {
			handler(val) {
				this.entity = {
					id: null,
					name: null,
				};

				this.refresh();
			},
		},
	},
};
</script>